import { BaseText, EBaseTextSize } from '@spinwise/react-component-library/BaseText';
import classNames from 'classnames';
import { EBrandTextColor } from 'Libraries/typography.library';
import styles from './EidBlock.module.scss';
import EidItem from './EidItem/EidItem';

export interface IEidBlock {
  title: string;
  eid_item: any;
  text_block: any;
}

const EidBlock = (props: IEidBlock) => {
  return (
    <div className={styles.eid_block}>
      {props?.title && <h2 className={styles.eid_block__title}>{props?.title}</h2>}
      {props.eid_item.map((el: any) => {
        return (
          <EidItem
            key={el?.title}
            eid={el?.identifier}
            title={el?.title}
            description={el?.description}
            is_table_shown={el?.is_table_shown}
            is_button_shown={el?.is_button_shown}
            btn_text={el?.btn_text}
            btn_url={el?.btn_url}
            authorized_btn_url={el?.authorized_btn_url}
            authorized_btn_text={el?.authorized_btn_text}
            override_bonus_image={el?.override_bonus_image}
            override_bonus_terms={el?.override_bonus_terms?.data?.attributes?.slug}
          ></EidItem>
        );
      })}
      {props.text_block.length > 0 && (
        /* TODO create in strapi new block for bonus conditions */
        <div
          className={classNames(styles.promo_bonus_text, 'd-fl fl-d-c')}
          style={{ paddingTop: props?.eid_item?.length === 0 ? '0' : '' }}
        >
          {props.text_block.map((el: any, i: any) => {
            return (
              <div className="d-fl fl-d-c" key={el?.title}>
                <BaseText value={el?.title} size={EBaseTextSize.Large} color={EBrandTextColor.DarkBlue} />
                <BaseText value={el?.description} size={EBaseTextSize.Regular} color={EBrandTextColor.Subtitle} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default EidBlock;
